import Preloader from '@/components/Preloader';
import React from 'react';
import { useAuth } from '../../providers/AuthProvider/hooks';

type Props = React.PropsWithChildren & {
  enabled?: boolean;
};

const AuthSetupPreloader: React.FC<Props> = ({ children, enabled = true }) => {
  const { status, setUp } = useAuth();

  React.useEffect(() => {
    if (enabled && status === 'unknown') {
      setUp();
    }
  }, [enabled, setUp, status]);

  return (
    <Preloader
      message="Aguarde, estamos carregando tudo para você."
      loading={enabled && status === 'unknown'}
    >
      {children}
    </Preloader>
  );
};

export default AuthSetupPreloader;
